
<template>
    <div id='myBox' class='box'></div>
</template>

<script >
    export default {
        props : ['color','size','row','col'],     
        data : function(){
            return {
                link:"",
                img:"",
            } 
        },
        mounted: function(){
            let box = document.getElementById('myBox');
            box.style.height=this.size + 'px';
            box.style.width=this.size + 'px';
            box.style.backgroundColor = '#'+this.color.substr(2);
            box.id=myBox+this.row+'-'+this.col;
        },
    }
</script>

<style scoped>
.box{
		float:left;
		border:1px solid white;
        clear: both;
	}
</style>